import LeadActions from '../actions/lead';
import AppActions from '../actions/app';
import { PHONE_COUNTRY_CODES } from '../phoneCountryCodes.js/constants';

const initialState = {
    email: '',
    emailValidation: {
        isValid: false,
        validationService: {
            isValid: false,
            start: false,
            success: false,
            fail: false
        }
    },
    entryTicketId: '',
    autoAuthUrl: '',
    titleName: undefined,
    firstName: '',
    firstNameValidation: { isValid: false },
    latinFirstName: '',
    latinFirstNameValidation: { isValid: false },
    joinId: '',
    propertyId: '',
    lastName: '',
    lastNameValidation: { isValid: false },
    latinLastName: '',
    latinLastNameValidation: { isValid: false },
    password: '',
    passwordValidation: { isValid: false },
    passwordServerValidation: {
        isValid: false,
        success: false,
        start: false,
        fail: false
    },
    phoneCountryCode: 'us',
    phoneCountryCodeDigits: '1',
    phoneNumber: '',
    phoneValidation: {
        isValid: false,
        validationService: {
            isValid: false,
            start: false,
            success: false,
            fail: false
        }
    },
    publicUuid: '',
    showLeadCreationError: false,
    newSupplier: true,
    emailOptOut: false,
    explicitlyChosen: false,
    website: '',
    webSiteValidation: { isValid: false },
    eligibilityStatus: '',
    userId: '',
    isPaperContractUser: false
};

export default (state = initialState, action) => {
    switch (action.type) {
    case LeadActions.SET_IS_PAPER_CONTRACT_USER:
        return { ...state, isPaperContractUser: action.isPaperContractUser };
    case LeadActions.SET_ELIGIBILITY_STATUS:
        return { ...state, eligibilityStatus: action.reason };
    case LeadActions.SET_MARKETING_EMAIL_SUBSCRIPTION:
        return { ...state, emailOptOut: action.isOptedOut, explicitlyChosen: true };
    case LeadActions.SET_EMAIL:
        return { ...state, email: action.email };
    case LeadActions.SET_EMAIL_VALIDATION:
        return {
            ...state,
            emailValidation: {
                ...state.emailValidation,
                ...action.result
            }
        };
    case LeadActions.VALIDATE_EMAIL_START:
        return {
            ...state,
            emailValidation: {
                ...state.emailValidation,
                validationService: {
                    isValid: false,
                    start: true,
                    success: false,
                    fail: false
                }
            }
        };
    case LeadActions.VALIDATE_EMAIL_FAIL:
        return {
            ...state,
            emailValidation: {
                ...state.emailValidation,
                // eslint-disable-next-line no-nested-ternary
                error: action.error
                    ? action.error.message
                        ? action.error.message
                        : action.error
                    : '',
                validationService: {
                    isValid: false,
                    start: false,
                    success: false,
                    fail: true
                }
            }
        };
    case LeadActions.VALIDATE_EMAIL_SUCCESS:
        return {
            ...state,
            emailValidation: {
                ...state.emailValidation,
                error: '',
                isValid: action?.validationService?.emailValidationResult || false,
                validationService: {
                    isValid: action?.validationService?.emailValidationResult || false,
                    start: false,
                    success: true,
                    fail: false
                }
            }
        };
    case LeadActions.VALIDATE_PHONE_START:
        return {
            ...state,
            phoneValidation: {
                ...state.phoneValidation,
                validationService: {
                    isValid: false,
                    start: true,
                    success: false,
                    fail: false
                }
            }
        };
    case LeadActions.VALIDATE_PHONE_FAIL:
        return {
            ...state,
            phoneValidation: {
                ...state.phoneValidation,
                validationService: {
                    isValid: false,
                    start: false,
                    success: false,
                    fail: true
                }
            }
        };
    case LeadActions.VALIDATE_PHONE_SUCCESS:
        return {
            ...state,
            phoneValidation: {
                ...state.phoneValidation,
                validationService: {
                    isValid: action.validationService
                        && action.validationService
                        ? action.validationService
                        : false,
                    start: false,
                    success: true,
                    fail: false
                }
            }
        };
    case LeadActions.SET_TITLE_NAME:
        return { ...state, titleName: action.titleName };
    case LeadActions.SET_FIRST_NAME:
        return { ...state, firstName: action.firstName };
    case LeadActions.SET_FIRST_NAME_VALIDATION:
        return { ...state, firstNameValidation: action.result };
    case LeadActions.SET_LAST_NAME:
        return { ...state, lastName: action.lastName };
    case LeadActions.SET_LAST_NAME_VALIDATION:
        return { ...state, lastNameValidation: action.result };
    case LeadActions.SET_LATIN_FIRST_NAME:
        return { ...state, latinFirstName: action.latinFirstName };
    case LeadActions.SET_LATIN_FIRST_NAME_VALIDATION:
        return { ...state, latinFirstNameValidation: action.result };
    case LeadActions.SET_LATIN_LAST_NAME:
        return { ...state, latinLastName: action.latinLastName };
    case LeadActions.SET_LATIN_LAST_NAME_VALIDATION:
        return { ...state, latinLastNameValidation: action.result };
    case LeadActions.SET_PHONE_COUNTRY_CODE:
        return {
            ...state,
            phoneCountryCode: action.code,
            phoneCountryCodeDigits: PHONE_COUNTRY_CODES[action.code] ? String(PHONE_COUNTRY_CODES[action.code].countryCode) : ''
        };
    case LeadActions.SET_PHONE_COUNTRY_CODE_DIGITS:
        return { ...state, phoneCountryCodeDigits: action.code };
    case LeadActions.SET_PASSWORD:
        return { ...state, password: action.password };
    case LeadActions.SET_PASSWORD_VALIDATION:
        return { ...state, passwordValidation: action.result };
    case LeadActions.PASSWORD_SERVER_VALIDATION_START:
        return {
            ...state,
            passwordServerValidation: {
                isValid: false,
                start: true,
                success: false,
                fail: false
            }
        };
    case LeadActions.PASSWORD_SERVER_VALIDATION_SUCCESS:
        return {
            ...state,
            passwordServerValidation: {
                isValid: action.value,
                start: false,
                success: true,
                fail: false
            }
        };
    case LeadActions.PASSWORD_SERVER_VALIDATION_FAIL:
        return {
            ...state,
            passwordServerValidation: {
                isValid: false,
                start: false,
                success: false,
                fail: true
            }
        };
    case LeadActions.SET_PASSWORD_SERVER_VALIDATION:
        return {
            ...state,
            passwordServerValidation: {
                isValid: action.result,
                start: false,
                success: true,
                fail: false
            }
        };
    case LeadActions.SET_PHONE_NUMBER:
        return { ...state, phoneNumber: action.number };
    case LeadActions.SET_PHONE_VALIDATION:
        return { ...state, phoneValidation: action.result };
    case LeadActions.SET_ENTRY_TICKET_ID:
        return { ...state, entryTicketId: action.entryTicketId };
    case LeadActions.SET_AUTO_AUTH_URL:
        return { ...state, autoAuthUrl: action.autoAuthUrl };
    case LeadActions.SET_PUBLIC_UUID:
        return { ...state, publicUuid: action.publicUuid };
    case LeadActions.SET_JOIN_ID:
        return {
            ...state, joinId: action.joinId, showLeadCreationError: false, eligibilityStatus: ''
        };
    case LeadActions.SET_PROPERTY_ID:
        return {
            ...state, propertyId: action.propertyId, showLeadCreationError: false, eligibilityStatus: ''
        };
    case LeadActions.SET_USER_ID:
        return { ...state, userId: action.userId };
    case LeadActions.SET_NEW_SUPPLIER:
        return { ...state, newSupplier: action.newSupplier };
    case LeadActions.LEAD_CREATION_FAILED:
        return { ...state, showLeadCreationError: action.failed };
    case LeadActions.SET_MISSING_INFO:
        return { ...state, missingInfo: action.missingInfo };
    case LeadActions.SET_WEBSITE:
        return { ...state, website: action.website };
    case LeadActions.SET_WEBSITE_VALIDATION:
        return { ...state, webSiteValidation: action.result };
    case AppActions.CREATE_ACCOUNT_SUCCESS:
        return {
            ...state,
            emailValidation: {
                isValid: false,
                validationService: {
                    isValid: false,
                    start: false,
                    success: false,
                    fail: false
                }
            },
            titleName: undefined,
            firstName: '',
            firstNameValidation: { isValid: false },
            latinFirstName: '',
            latinFirstNameValidation: { isValid: false },
            lastName: '',
            lastNameValidation: { isValid: false },
            latinLastName: '',
            latinLastNameValidation: { isValid: false },
            password: '',
            passwordValidation: { isValid: false },
            phoneCountryCode: 'us',
            phoneCountryCodeDigits: '1',
            phoneNumber: '',
            phoneValidation: {
                isValid: false,
                validationService: {
                    isValid: false,
                    start: false,
                    success: false,
                    fail: false
                }
            },
            showLeadCreationError: false,
            emailOptOut: false,
            explicitlyChosen: false
        };
    /**
     * This one probably should have been in LeadActions, not AppActions,
     * but it's already used in a few different places as AppActions, so
     * I'm just adding it to the lead reducer so we can correctly set the
     * auto auth URL when an account update finishes successfully.
     */
    case AppActions.UPDATE_ACCOUNT_SUCCESS:
        return {
            ...state,
            autoAuthUrl: action.updateAccountData.vrboContact.autoAuthUrl
        };
    default:
        return state;
    }
};
